export type Options = {
  readonly label: string
  readonly value: number
}[]
export const statusList: Options = [
  { label: '停止中', value: 0 },
  { label: '待機中', value: 1 },
  { label: '処理中', value: 2 },
  { label: '分析済', value: 8 },
  { label: 'エラー', value: 9 },
]

export const cancerStatusList: Options = [
  { label: '待機', value: 0 },
  { label: '分析済', value: 1 },
]

export const dpcStatusList: Options = [
  { label: '待機', value: 0 },
  { label: '分析済', value: 1 }
]

export const journalStatusList: Options = [
  { label: '待機', value: 0 },
  { label: '分析済', value: 1 }
]

export const trialStatusList: Options = [
  { label: '待機', value: 0 },
  { label: '分析済', value: 1 }
]

export const senmoniStatusList: Options = [
  { label: '待機', value: 0 },
  { label: '分析済', value: 1 },
]

export const guidelineStatusList: Options = [
  { label: '待機', value: 0 },
  { label: '分析済', value: 1 },
]

export const researchStatusList: Options = [
  { label: '待機', value: 0 },
  { label: '分析済', value: 1 },
]